<template>
  <div class="course-info-page" :class="isAuth ? 'is-auth' : ''">
    <div class="left_block course-info">
      <div class="header">
        <div class="header-overlay">
          {{ courseInfo.category_name }} <i style="font-size: 10px;" class="icon-button-arrow"></i>
          {{ courseInfo.name }}
        </div>
      </div>

      <div class="course-info-header" :style="{ backgroundImage: courseInfoImage }">
        <div class="row">
          <div class="course_name">
            {{ courseInfo.name }}
          </div>
        </div>
        <div class="row">
          <ul>
            <li>
              <span>Проходят всего</span>
              <span class="black">{{ courseInfo.new_count }}</span>
            </li>
            <li>
              <span>Прошли</span>
              <span class="black">{{ courseInfo.passed_count }}</span>
            </li>
            <li>
              <span>В процессе</span>
              <span class="black">{{ courseInfo.in_the_process_count }}</span>
            </li>
            <li>
              <span>Не прошли курс</span>
              <span class="black">{{ courseInfo.not_passed_count }}</span>
            </li>
          </ul>
        </div>
        <div class="row" v-if="userRole == 'user' && isButtonShow">
          <button @click="startStage(stagesList[0], 0)" class="course-card-button">
            {{ isAuth ? 'Начать обучение' : 'Оставить заявку' }}
          </button>
        </div>
      </div>
      <div class="course-info-description">
        <h1>Описание</h1>
        <div class="description-block">{{ courseInfo.description }}</div>
        <h1>Материалы курса</h1>
        <ul class="materials-block" v-if="stagesList.length">
          <li
            :style="{ cursor: isAuth ? 'pointer' : 'default' }"
            v-for="(stage, i) in stagesList"
            :key="i"
            @click="startStage(stage, i)"
            class="materials-block__item"
            :class="calcClass(i, stagesList)"
          >
            <span class="left">
              <i v-if="stage.type === 1" class="icon-play"></i>
              <i v-if="stage.type === 2" class="icon-pie-chart"></i>
              <i v-if="stage.type === 3" class="icon-test"></i>
              {{ stage.name }}
            </span>
            <span class="right">
              <span class="time">
                {{ stage.duration ? stage.duration + ' мин' : '' }}
              </span>
            </span>
          </li>
        </ul>
        <!-- <h1>Отзывы</h1>
            <ul class="reviews-block">
               <li v-for="(item, i) in 3" :key="i">
                  <div class="review-image"></div>
                  <div class="review-info">
                     <div class="review-name">Гришина Снежана</div>
                     <div class="review-time">10 дней назад</div>
                     <div class="review-stars">
                        <i class="mdi mdi-star active"></i>
                        <i class="mdi mdi-star active"></i>
                        <i class="mdi mdi-star active"></i>
                        <i class="mdi mdi-star active"></i>
                        <i class="mdi mdi-star"></i>
                     </div>
                  </div>
                  <div class="review-text">
                     Товарищи! дальнейшее развитие различных форм деятельности позволяет оценить значение существенных
                     финансовых и административных условий. Идейные соображения высшего порядка, а также сложившаяся
                     структура организации в значительной степени обуславливает создание форм развития. Значимость этих
                     проблем настолько очевидна, что постоянный количественный рост и сфера нашей активности требуют от
                     нас анализа форм развития.
                  </div>
               </li>
            </ul> -->
      </div>
    </div>

    <div class="right_block" v-if="!isAuth">
      <CourseCard :course-info="courseInfo" :stages-list="stagesList" />
    </div>
  </div>
</template>

<script>
import CourseCard from '@/components/right_block/CourseCard'
import { toastDanger } from '@/lib/toastCfg'
import { config } from '@/config'

export default {
  components: {
    CourseCard
  },
  methods: {
    calcClass(index, array) {
      if (!this.isAuth || this.userRole !== 'user' || index === 0 || array[index - 1].passed) return ''
      return 'materials-block__item--disabled'
    },
    loadData() {
      this.$axios2
        .get('courses/' + this.courseId)
        .then((resp) => {
          this.$store.commit('setCoursePageInfo', { list: resp.data })
        })
        .catch(this.$errorToast)
      this.$axios2
        .get('courses/' + this.courseId + '/stages')
        .then((resp) => {
          this.$store.commit('setInfoStagesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    },
    async startStage(stage, index) {
      if (!this.isAuth) {
        return
      }
      if (this.userRole === 'leader' && this.branchInfo.id !== this.profileInfo.branch.id) {
        await this.$axios2
          .get('branches/' + this.profileInfo.branch.id)
          .then((resp) => {
            this.$store.commit('setBranchInfo', { list: resp.data })
          })
          .catch(this.$errorToast)
      }
      if (
        this.userRole === 'admin' ||
        this.userRole === 'methodist' ||
        (this.userRole === 'leader' && this.branchInfo.courses.some((el) => el.id === this.courseId))
      ) {
        this.$router.push('/course-preview/' + stage.course_id + '?stageIndex=' + stage.sort_number)
        return
      }
      if (!this.isButtonShow) {
        this.$buefy.toast.open(toastDanger('Вы не назначены на курс'))
        return
      }
      const currentCourse = this.rightCoursesList.find((el) => el.id === this.courseId)
      if (currentCourse.stages[index - 1] && !currentCourse.stages[index - 1].passed) {
        this.$buefy.toast.open(toastDanger('Пройдите предыдущие уроки курса'))
        return
      }
      if (this.$moment(currentCourse.date_start).isAfter(this.$moment(new Date()))) {
        this.$buefy.toast.open(toastDanger('Дождитесь даты начала прохождения курса'))
        return
      }
      let date_end = this.$moment(currentCourse.date_start).add(this.courseInfo.days_limit, 'days').format('YYYY-MM-DD')
      if (this.$moment(date_end).isBefore(this.$moment(new Date()))) {
        if (Number(stage.type) !== 1) {
          this.$buefy.toast.open(toastDanger('Время прохождения курса истекло'))
          return
        }
        this.$router.push('/my-courses/' + stage.id + '?courseId=' + this.courseId)
        return
      }
      this.$router.push('/my-courses/' + stage.id + '?courseId=' + this.courseId)
    }
  },
  computed: {
    categoriesList() {
      return this.$store.state.categories.categoriesList
    },
    branchInfo() {
      return this.$store.state.branches.branchInfo
    },
    isButtonShow() {
      return this.rightCoursesList && this.rightCoursesList.some((el) => el.id === this.courseInfo.id)
    },
    isAuth() {
      return this.$store.state.auth.auth
    },
    courseId() {
      return Number(this.$route.params.id)
    },
    userRole() {
      return this.$store.state.auth.role[0]
    },
    rightCoursesList() {
      return this.$store.state.courses.userRightCoursesList.courses
    },
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    stagesList() {
      return this.$store.state.courses.infoStagesList
    },
    courseInfo() {
      let data = this.$store.state.courses.coursePageInfo
      const currentCategory = this.categoriesList.find((el) => el.id === data.category_id)
      if (!currentCategory) {
        return data
      }
      data['category_name'] = currentCategory.name
      return data
    },
    courseInfoImage() {
      if (this.courseInfo.image) {
        return `url(${config.baseUrl + this.courseInfo.image})`
      } else {
        return ''
      }
    }
  },
  mounted() {
    this.loadData()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === this.$route.name) {
      next()
      this.loadData()
    }
  }
}
</script>
